export const CRYPTO_LOGOS = {
  BTC: 'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  ETH: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
  USDT: 'https://assets.coingecko.com/coins/images/325/small/Tether.png',
  USDC: 'https://assets.coingecko.com/coins/images/6319/small/usdc.png',
  BNB: 'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png',
  SOL: 'https://assets.coingecko.com/coins/images/4128/small/solana.png',
  XRP: 'https://cryptologos.cc/logos/xrp-xrp-logo.png',
  ADA: 'https://assets.coingecko.com/coins/images/975/small/cardano.png',
  AVAX: 'https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png',
  DOGE: 'https://assets.coingecko.com/coins/images/5/small/dogecoin.png',
  DOT: 'https://assets.coingecko.com/coins/images/12171/small/polkadot.png',
  MATIC: 'https://assets.coingecko.com/coins/images/4713/small/polygon.png',
  LTC: 'https://assets.coingecko.com/coins/images/2/small/litecoin.png',
  LINK: 'https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png',
  UNI: 'https://assets.coingecko.com/coins/images/12504/small/uniswap-logo.png',
  ATOM: 'https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png',
  NEAR: 'https://assets.coingecko.com/coins/images/10365/small/near.png',
  APT: 'https://assets.coingecko.com/coins/images/26455/small/aptos_round.png',
  ARB: 'https://assets.coingecko.com/coins/images/16547/small/arb.jpg',
  OP: 'https://assets.coingecko.com/coins/images/25244/small/Optimism.png',
  SHIB: 'https://assets.coingecko.com/coins/images/11939/small/shiba.png',
  TRX: 'https://assets.coingecko.com/coins/images/1094/small/tron-logo.png',
};

export const FIAT_FLAGS = {
  EUR: 'european_union', USD: 'us', GBP: 'gb', CHF: 'ch', RUB: 'ru',
  CNY: 'cn', JPY: 'jp', KRW: 'kr', INR: 'in', THB: 'th', VND: 'vn',
  PHP: 'ph', CAD: 'ca',
};

export const flagUrl = (code) => `https://hatscripts.github.io/circle-flags/flags/${code.toLowerCase()}.svg`;

export const currencyLogo = (symbol) => {
  if (CRYPTO_LOGOS[symbol]) return CRYPTO_LOGOS[symbol];
  if (FIAT_FLAGS[symbol]) return flagUrl(FIAT_FLAGS[symbol]);
  return null;
};
